import { render } from "./PoliticadecancelacionesView.vue?vue&type=template&id=7277f5da&scoped=true"
const script = {}

import "./PoliticadecancelacionesView.vue?vue&type=style&index=0&id=7277f5da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7277f5da"]])

export default __exports__